// src/store/clinicianSlice.js

import { createSlice } from '@reduxjs/toolkit';

const chatWindowSlice = createSlice({
    name: 'lastChatUser',
    initialState: {
        lastChatUser: null,
        unreadCount: 0,
    },
    reducers: {
        setLastChatUser: (state, action) => {
            state.lastChatUser = action.payload;
        },
        clearLastChatUser: (state) => {
            state.lastChatUser = null;
        },
        setUnreadCount: (state, action) => {
            state.unreadCount = action.payload;
        },
    },
});

export const { setLastChatUser, clearLastChatUser, setUnreadCount } = chatWindowSlice.actions;
export default chatWindowSlice.reducer;
